import { useIntl } from 'react-intl';

import { PageHeaderAction } from '@verantos-dev/shared-components';

import { ProjectDialogType, useProjectModalContext } from '../context/modalContext';

export const useProjectsListPageHeader = () => {
  const intl = useIntl();
  const { openDialog, activeDialog, datasetInfo } = useProjectModalContext();

  const onCreateProjectButtonClick = () => {
    openDialog(ProjectDialogType.CREATE_PROJECT);
  };

  const actions: PageHeaderAction[] = [
    {
      id: 'createProjectButton',
      startIcon: 'add',
      label: intl.formatMessage({
        id: 'projectsList.pageHeader.createProjectButton',
        defaultMessage: 'Create project',
      }),
      onClickHandler: onCreateProjectButtonClick,
    },
  ];

  return {
    pageTitle: intl.formatMessage({
      id: 'projectsList.pageHeader.title',
      defaultMessage: 'Projects',
    }),
    actions,
    isCreateProjectModalOpen: activeDialog === ProjectDialogType.CREATE_PROJECT,
    isDeleteProjectModalOpen: activeDialog === ProjectDialogType.DELETE_PROJECT,
    isDatasetDetailsModalOpen: activeDialog === ProjectDialogType.DATASET_DETAILS,
    datasetInfo,
  };
};
